/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CountryTaxProfile,
  DealTradeTerms,
  DealTradeTermsSaveRequest,
  EstimateRequestRequest,
  EstimateResponse,
  PatchedDealTradeTermsSaveRequest
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * The destinations with curated tax data: VAT/GST, valuation basis, customs union, provinces/states and their sales taxes, with the source and as-of date. Other destinations get fallback ranges.
 * @summary Countries with duty and tax data
 */
export const tradeCostsCountriesList = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<CountryTaxProfile[]>(
      {url: `/api/v1/tradeCosts/countries/`, method: 'GET', signal
    },
      );
    }
  

export const getTradeCostsCountriesListQueryKey = () => {
    return [`/api/v1/tradeCosts/countries/`] as const;
    }

    
export const getTradeCostsCountriesListQueryOptions = <TData = Awaited<ReturnType<typeof tradeCostsCountriesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeCostsCountriesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTradeCostsCountriesListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tradeCostsCountriesList>>> = ({ signal }) => tradeCostsCountriesList(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tradeCostsCountriesList>>, TError, TData> & { queryKey: QueryKey }
}

export type TradeCostsCountriesListQueryResult = NonNullable<Awaited<ReturnType<typeof tradeCostsCountriesList>>>
export type TradeCostsCountriesListQueryError = unknown

/**
 * @summary Countries with duty and tax data
 */
export const useTradeCostsCountriesList = <TData = Awaited<ReturnType<typeof tradeCostsCountriesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeCostsCountriesList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTradeCostsCountriesListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * The estimate for the deal's saved trade terms (the HS code falls back to the matched product's). Super moderator, the assigned moderator, or either company of the deal. A local, free **estimate as a range**, never a single figure: customs value on the destination's valuation basis (CIF for the GCC; transaction value excluding international freight for Canada), duty from the rates under the HS code (a shallow code gives a wider range; the destination's own rates take precedence over its customs union's), trade-remedy surtaxes (high side only), excise, VAT/GST and provincial taxes (gross and net of reclaim for registered importers) and rough broker/port fees. Every response lists its assumptions, warnings (prohibitions, quotas, anti-dumping), confidence with reasons, sources with as-of dates and the "not a customs ruling" disclaimer. Amounts are in the input currency. Destinations without data get wide fallback ranges with low confidence.
 * @summary Duty and tax estimate for a deal
 */
export const tradeCostsDealsEstimateRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EstimateResponse>(
      {url: `/api/v1/tradeCosts/deals/${id}/estimate/`, method: 'GET', signal
    },
      );
    }
  

export const getTradeCostsDealsEstimateRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/tradeCosts/deals/${id}/estimate/`] as const;
    }

    
export const getTradeCostsDealsEstimateRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof tradeCostsDealsEstimateRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeCostsDealsEstimateRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTradeCostsDealsEstimateRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tradeCostsDealsEstimateRetrieve>>> = ({ signal }) => tradeCostsDealsEstimateRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tradeCostsDealsEstimateRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type TradeCostsDealsEstimateRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof tradeCostsDealsEstimateRetrieve>>>
export type TradeCostsDealsEstimateRetrieveQueryError = void

/**
 * @summary Duty and tax estimate for a deal
 */
export const useTradeCostsDealsEstimateRetrieve = <TData = Awaited<ReturnType<typeof tradeCostsDealsEstimateRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeCostsDealsEstimateRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTradeCostsDealsEstimateRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * The shipment behind a deal (origin, destination and province, HS code, Incoterm, value and currency, freight, insurance, quantity and unit, importer's VAT registration), used for its duty and tax estimate. `isSet` is false until a moderator saves them; `suggested` gives defaults from the deal. Super moderator, the assigned moderator, or either company of the deal.
 * @summary A deal's trade terms
 */
export const tradeCostsDealsTermsRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DealTradeTerms>(
      {url: `/api/v1/tradeCosts/deals/${id}/terms/`, method: 'GET', signal
    },
      );
    }
  

export const getTradeCostsDealsTermsRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/tradeCosts/deals/${id}/terms/`] as const;
    }

    
export const getTradeCostsDealsTermsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof tradeCostsDealsTermsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeCostsDealsTermsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTradeCostsDealsTermsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tradeCostsDealsTermsRetrieve>>> = ({ signal }) => tradeCostsDealsTermsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tradeCostsDealsTermsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type TradeCostsDealsTermsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof tradeCostsDealsTermsRetrieve>>>
export type TradeCostsDealsTermsRetrieveQueryError = void

/**
 * @summary A deal's trade terms
 */
export const useTradeCostsDealsTermsRetrieve = <TData = Awaited<ReturnType<typeof tradeCostsDealsTermsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeCostsDealsTermsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTradeCostsDealsTermsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Upsert; omitted fields keep their value. Super moderator or the deal's assigned moderator.
 * @summary Save a deal's trade terms
 */
export const tradeCostsDealsTermsUpdate = (
    id: number,
    dealTradeTermsSaveRequest: DealTradeTermsSaveRequest,
 ) => {
      
      
      return customInstance<DealTradeTerms>(
      {url: `/api/v1/tradeCosts/deals/${id}/terms/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: dealTradeTermsSaveRequest
    },
      );
    }
  


export const getTradeCostsDealsTermsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tradeCostsDealsTermsUpdate>>, TError,{id: number;data: DealTradeTermsSaveRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof tradeCostsDealsTermsUpdate>>, TError,{id: number;data: DealTradeTermsSaveRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tradeCostsDealsTermsUpdate>>, {id: number;data: DealTradeTermsSaveRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  tradeCostsDealsTermsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TradeCostsDealsTermsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof tradeCostsDealsTermsUpdate>>>
    export type TradeCostsDealsTermsUpdateMutationBody = DealTradeTermsSaveRequest
    export type TradeCostsDealsTermsUpdateMutationError = void

    /**
 * @summary Save a deal's trade terms
 */
export const useTradeCostsDealsTermsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tradeCostsDealsTermsUpdate>>, TError,{id: number;data: DealTradeTermsSaveRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof tradeCostsDealsTermsUpdate>>,
        TError,
        {id: number;data: DealTradeTermsSaveRequest},
        TContext
      > => {

      const mutationOptions = getTradeCostsDealsTermsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Same as PUT.
 * @summary Save a deal's trade terms
 */
export const tradeCostsDealsTermsPartialUpdate = (
    id: number,
    patchedDealTradeTermsSaveRequest: PatchedDealTradeTermsSaveRequest,
 ) => {
      
      
      return customInstance<DealTradeTerms>(
      {url: `/api/v1/tradeCosts/deals/${id}/terms/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedDealTradeTermsSaveRequest
    },
      );
    }
  


export const getTradeCostsDealsTermsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tradeCostsDealsTermsPartialUpdate>>, TError,{id: number;data: PatchedDealTradeTermsSaveRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof tradeCostsDealsTermsPartialUpdate>>, TError,{id: number;data: PatchedDealTradeTermsSaveRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tradeCostsDealsTermsPartialUpdate>>, {id: number;data: PatchedDealTradeTermsSaveRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  tradeCostsDealsTermsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TradeCostsDealsTermsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof tradeCostsDealsTermsPartialUpdate>>>
    export type TradeCostsDealsTermsPartialUpdateMutationBody = PatchedDealTradeTermsSaveRequest
    export type TradeCostsDealsTermsPartialUpdateMutationError = void

    /**
 * @summary Save a deal's trade terms
 */
export const useTradeCostsDealsTermsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tradeCostsDealsTermsPartialUpdate>>, TError,{id: number;data: PatchedDealTradeTermsSaveRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof tradeCostsDealsTermsPartialUpdate>>,
        TError,
        {id: number;data: PatchedDealTradeTermsSaveRequest},
        TContext
      > => {

      const mutationOptions = getTradeCostsDealsTermsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Signed-in companies and moderators. A local, free **estimate as a range**, never a single figure: customs value on the destination's valuation basis (CIF for the GCC; transaction value excluding international freight for Canada), duty from the rates under the HS code (a shallow code gives a wider range; the destination's own rates take precedence over its customs union's), trade-remedy surtaxes (high side only), excise, VAT/GST and provincial taxes (gross and net of reclaim for registered importers) and rough broker/port fees. Every response lists its assumptions, warnings (prohibitions, quotas, anti-dumping), confidence with reasons, sources with as-of dates and the "not a customs ruling" disclaimer. Amounts are in the input currency. Destinations without data get wide fallback ranges with low confidence.
 * @summary Estimate duty and taxes (range)
 */
export const tradeCostsEstimateCreate = (
    estimateRequestRequest: EstimateRequestRequest,
 ) => {
      
      
      return customInstance<EstimateResponse>(
      {url: `/api/v1/tradeCosts/estimate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: estimateRequestRequest
    },
      );
    }
  


export const getTradeCostsEstimateCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tradeCostsEstimateCreate>>, TError,{data: EstimateRequestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof tradeCostsEstimateCreate>>, TError,{data: EstimateRequestRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tradeCostsEstimateCreate>>, {data: EstimateRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  tradeCostsEstimateCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TradeCostsEstimateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tradeCostsEstimateCreate>>>
    export type TradeCostsEstimateCreateMutationBody = EstimateRequestRequest
    export type TradeCostsEstimateCreateMutationError = void

    /**
 * @summary Estimate duty and taxes (range)
 */
export const useTradeCostsEstimateCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tradeCostsEstimateCreate>>, TError,{data: EstimateRequestRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof tradeCostsEstimateCreate>>,
        TError,
        {data: EstimateRequestRequest},
        TContext
      > => {

      const mutationOptions = getTradeCostsEstimateCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    